// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sidebar[data-v-31b1b866]{background:linear-gradient(180deg,#5186ef 50%,#9affcd);width:100px;min-height:100vh}.content[data-v-31b1b866]{background:#ddf1f7;width:calc(100vw - 100px);min-height:100vh;overflow:auto;padding:1rem}.active_tab[data-v-31b1b866]{background:hsla(0,0%,100%,.25)}.inactive_tab[data-v-31b1b866]:hover{background:hsla(0,0%,100%,.05)}", ""]);
// Exports
module.exports = exports;
